import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const DownloadOption = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='DownloadOption' {...props}>
    <path fillRule='evenodd' clipRule='evenodd' d='M12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24ZM2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12ZM16.2929 11.2929L13 14.5858V6H11V14.5858L7.70711 11.2929L6.29289 12.7071L11.2929 17.7071L12 18.4142L12.7071 17.7071L17.7071 12.7071L16.2929 11.2929Z' fill='#000' />
  </StyledIcon>
);
